let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bgja4")).then(() => parcelRequire('hpjZ8'));